import { useEffect } from "react";
import AcceleratorDoc from "../../models/AcceleratorDoc";
import { SpanHighlightObject } from "../../models/HighlightObject";
import Span from "../../models/Span";
import { useSpanHighlightDispatch } from "../highlightProvider/SpanHighlightProvider";
import { usePageState } from "../pageProvider/PageProvider";

/**
 * Use page state to calculate
 * @param highlightKey
 * @param color
 * @param acceleratorDoc
 * @param visible
 */
function useHighlightAllSpans(
  highlightKey: string,
  color: string,
  acceleratorDoc?: AcceleratorDoc,
  visible: boolean = false,
) {
  const pageState = usePageState();
  const highlightDispatch = useSpanHighlightDispatch();

  useEffect(() => {
    let mounted = true;
    if (!acceleratorDoc) return;
    if (!visible) return;
    if (pageState.pageIndex === -1) return;

    console.log("Rendering page spans for pageIndex " + pageState.pageIndex);
    acceleratorDoc.getPageSpans(pageState.pageIndex).then((pageSpans) => {
      const spanHighlights = pageSpans.spans.map(
        (span: Span): SpanHighlightObject => ({
          id: highlightKey,
          bordered: true,
          color: color,
          width: span.width,
          height: span.height,
          objectMoved: () => null,
          opacity: 1,
          pageIndex: span.pageIndex,
          visible,
          x: span.x,
          y: span.y,
          type: "SPAN",
        }),
      );

      if (mounted) {
        console.log(
          "Dispatch " + spanHighlights.length + " new span highlights",
        );
        highlightDispatch({
          type: "set",
          docUuid: acceleratorDoc.uuid,
          pageIndex: pageState.pageIndex,
          highlight: spanHighlights,
          enabled: true,
        });
      }
    });

    return function () {
      mounted = false;
      highlightDispatch({
        type: "set",
        docUuid: acceleratorDoc.uuid,
        pageIndex: pageState.pageIndex,
        highlight: [] as SpanHighlightObject[],
        enabled: false,
      });
    };
  }, [highlightKey, color, visible, pageState.pageIndex]);
}

export { useHighlightAllSpans };
